<template>
  <div class="col-sm-12 col-xl-6">
    <div class="card">
      <div class="card-header pb-0">
        <h3>Dropdown With Divider</h3><span>Use a class </span>
      </div>
      <div class="card-body dropdown-basic">
        <div class="dropdown">
          <button class="dropbtn btn-primary" type="button">Dropdown Button <span><i class="icofont icofont-arrow-down"></i></span></button>
          <div class="dropdown-content"><a href="javascript:void(0)">Link 1</a><a href="javascript:void(0)">Link 2</a><a href="javascript:void(0)">Link 3</a><a href="javascript:void(0)">Another Link</a></div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-12 col-xl-6">
    <div class="card">
      <div class="card-header pb-0">
        <h3>Dropdown With Header</h3><span>Use a class <code>.dropdown-header</code></span>
      </div>
      <div class="card-body dropdown-basic">
        <div class="dropdown">
          <button class="dropbtn btn-primary" type="button">Dropdown Button <span><i class="icofont icofont-arrow-down"></i></span></button>
          <div class="dropdown-content">
            <h5 class="dropdown-header">Dropdown header</h5><a href="javascript:void(0)">Link 1</a><a href="javascript:void(0)">Link 2</a>
            <h5 class="dropdown-header">Dropdown header</h5><a href="javascript:void(0)">Another Link</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-12 col-xl-6">
    <div class="card">
      <div class="card-header pb-0">
        <h3>Dropdown With Disable</h3><span>Use a class <code>.dropdown-disabled</code></span>
      </div>
      <div class="card-body dropup-basic dropdown-basic">
        <div class="dropup dropdown">
          <button class="dropbtn btn-primary" type="button">Dropdown Button <span><i class="icofont icofont-arrow-up"></i></span></button>
          <div class="dropup-content dropdown-content"><a href="javascript:void(0)">Normal</a><a class="active" href="javascript:void(0)">Active</a><a class="disabled" href="javascript:void(0)">Disabled</a></div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-12 col-xl-6">
    <div class="card">
      <div class="card-header pb-0">
        <h3>Dropdown With DropUp</h3><span>Use a class <code>.drop-up</code></span>
      </div>
      <div class="card-body dropup-basic dropdown-basic">
        <div class="dropup dropdown">
          <button class="dropbtn btn-primary" type="button">Dropdown Button <span><i class="icofont icofont-arrow-up"></i></span></button>
          <div class="dropup-content dropdown-content"><a href="javascript:void(0)">Link 1</a><a href="javascript:void(0)">Link 2</a></div>
        </div>
      </div>
    </div>
  </div>
</template>